module.exports = __webpack_public_path__ + "img/marketIcon.25bf6dc2.svg";